import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

export const Pricing = () => {
    return (
        <section id="pricing" style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-secondary)', position: 'relative' }}>
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                    <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                        No Risk. Unlimited Growth.
                    </h2>
                    <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                        Start for free. Scale when you generate revenue.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '32px', maxWidth: '1000px', margin: '0 auto' }}>
                    <div className="glass-panel" style={{ padding: '48px', position: 'relative', overflow: 'hidden', border: '1px solid var(--border-focus)', background: 'var(--bg-primary)' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '16px' }}>Starter Model</div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 800, fontFamily: 'var(--font-display)', marginBottom: '8px' }}>Free</div>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>Everything you need to launch immediately.</p>
                        <Link to="/contact" className="btn btn-outline" style={{ width: '100%', marginBottom: '40px', padding: '16px', textDecoration: 'none', textAlign: 'center' }}>Get Started</Link>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>No Monthly Subscription</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>Unlimited Staff & Tables</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>Core Dashboards & Features</span>
                            </div>

                        </div>
                    </div>

                    <div className="glass-panel" style={{ padding: '48px', position: 'relative', overflow: 'hidden', border: '1px solid var(--accent-primary)', background: 'var(--bg-tertiary)' }}>
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'var(--accent-primary)' }}></div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '16px', color: 'var(--accent-primary)' }}>Enterprise</div>
                        <div style={{ fontSize: '3.5rem', fontWeight: 800, fontFamily: 'var(--font-display)', marginBottom: '8px' }}>Custom</div>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>For large hospitality groups and franchises.</p>
                        <Link to="/contact" className="btn btn-primary" style={{ width: '100%', marginBottom: '40px', padding: '16px', textDecoration: 'none', textAlign: 'center' }}>Contact Sales</Link>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>Custom POS Integrations</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>White-labeling Options</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>Dedicated Account Manager</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>Bespoke Analytics & Reporting</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Check size={20} color="var(--accent-primary)" />
                                <span>Negotiated Processing Rates</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
